<template>
  <div class="complaint-detail-container padding">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between align-center">
        <span>{{ $t('complaintDetail.title') }}</span>
        <el-button type="link" size="mini" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
      </div>

      <!-- 鍩烘湰淇℃伅 -->
      <div class="card-content">
        <el-row :gutter="20" class="info-section text-left">
          <el-col :span="8">
            <div class="info-item">
              <label>{{ $t('adminComplaint.table.complaintId') }}：</label>
              <span>{{ complaintDetail.complaintNo }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <label>{{ $t('adminComplaint.table.status') }}：</label>
              <el-tag :type="getStatusTagType(complaintDetail.status)" size="small">
                {{ complaintDetail.statusText }}
              </el-tag>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <label>{{ $t('adminComplaint.table.createTime') }}：</label>
              <span>{{ complaintDetail.createTime }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="info-section text-left">
          <el-col :span="12">
            <div class="info-item">
              <label>{{ $t('adminComplaint.table.contact') }}：</label>
              <span>{{ complaintDetail.ownerName }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <label>{{ $t('adminComplaint.table.contactTel') }}：</label>
              <span>{{ complaintDetail.contactPhone }}</span>
            </div>
          </el-col>
        </el-row>

        <!-- 鎶曡瘔鍐呭 -->
        <el-row :gutter="20" class="info-section text-left">
          <el-col :span="24">
            <div class="info-item vertical">
              <label>{{ $t('adminComplaint.table.content') }}：</label>
              <div class="content-text">
                {{ complaintDetail.content }}
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- 鎶曡瘔鍥剧墖 -->
        <el-row v-if="problemImageList.length" :gutter="20" class="info-section text-left">
          <el-col :span="24">
            <div class="info-item vertical">
              <label>问题图片：</label>
              <div class="image-list">
                <el-image
                  v-for="(img, index) in problemImageList"
                  :key="index"
                  :src="img"
                  :preview-src-list="problemImageList"
                  fit="cover"
                  class="detail-image"
                />
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- 澶勭悊缁撴灉锛堝凡瀹屾垚鏃舵樉绀猴紝涓庡皬绋嬪簭涓鑷达級 -->
        <el-row v-if="complaintDetail.status === 2 || complaintDetail.status === '2'" :gutter="20"
          class="info-section text-left">
          <el-col :span="24">
            <div class="info-item vertical">
              <label>处理结果：</label>
              <div class="content-text">
                {{ complaintDetail.rateInfo || '-' }}
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- 澶勭悊鍥剧墖 -->
        <el-row v-if="rateImageList.length" :gutter="20" class="info-section text-left">
          <el-col :span="24">
            <div class="info-item vertical">
              <label>处理图片：</label>
              <div class="image-list">
                <el-image
                  v-for="(img, index) in rateImageList"
                  :key="index"
                  :src="img"
                  :preview-src-list="rateImageList"
                  fit="cover"
                  class="detail-image"
                />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 操作按钮，状态为待处理时显示（参考小程序：status == 0） -->
      <div class="action-bar" v-if="complaintDetail.status === 0 || complaintDetail.status === '0'">
        <el-button type="primary" @click="openHandleDialog">立即处理</el-button>
        <el-button type="warning" @click="handleConvertToRepair">转工单</el-button>
      </div>
    </el-card>

    <!-- 澶勭悊鎶曡瘔寮圭獥 -->
    <el-dialog
      title="处理投诉"
      :visible.sync="handleDialogVisible"
      width="600px"
     
    >
      <el-form :model="handleForm" label-width="80px">
        <el-form-item label="处理结果">
          <el-input
            v-model="handleForm.rateInfo"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入处理内容"
          />
        </el-form-item>
        <el-form-item label="处理图片" class="handle-upload-item">
          <el-upload
            action=""
            list-type="picture-card"
            :file-list="handleImages"
            :on-preview="handlePicturePreview"
            :on-remove="handlePictureRemove"
            :auto-upload="true"
            :http-request="uploadHandleImage"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="handleSubmitting" @click="submitHandle">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listComplaintOrders, saveOrUpdateComplaintOrder } from '@/api/complaint/adminComplaintApi'
import { uploadImage as uploadOwnerImage } from '@/api/owner/ownerApi'

export default {
  name: 'AdminComplaintDetail',
  data() {
    return {
      complaintId: '',
      complaintDetail: {
        id: '',
        complaintNo: '',
        ownerId: '',
        ownerName: '',
        contactPhone: '',
        createTime: '',
        content: '',
        status: '',
        statusText: '',
        problemImgs: '',
        rateInfo: '',
        rateImgs: '',
        communityId: '',
        communityName: '',
        repairId: ''
      },
      handleDialogVisible: false,
      handleForm: {
        rateInfo: ''
      },
      handleImages: [],
      handleSubmitting: false
    }
  },
  computed: {
    problemImageList() {
      return this.parseImages(this.complaintDetail.problemImgs)
    },
    rateImageList() {
      return this.parseImages(this.complaintDetail.rateImgs)
    }
  },
  created() {
    this.complaintId = this.$route.query.complaintId || this.$route.query.id || ''
    this.loadComplaintDetail()
  },
  methods: {
    async loadComplaintDetail() {
      if (!this.complaintId) {
        this.$message.warning('缺少投诉ID')
        return
      }
      try {
        const params = {
          id: this.complaintId,
          page: 1,
          row: 1
        }
        const { data } = await listComplaintOrders(params)
        if (data && data.length > 0) {
          const complaint = data[0]
          const statusText = this.getStatusText(complaint.status)
          this.complaintDetail = {
            ...complaint,
            complaintNo: complaint.complaintNo || '',
            ownerName: complaint.ownerName || '',
            contactPhone: complaint.contactPhone || '',
            content: complaint.content || '',
            status: complaint.status,
            statusText,
            problemImgs: complaint.problemImgs || '',
            rateInfo: complaint.rateInfo || '',
            rateImgs: complaint.rateImgs || '',
            communityId: complaint.communityId || '',
            communityName: complaint.communityName || '',
            repairId: complaint.repairId || ''
          }
        } else {
          this.$message.warning('未找到投诉信息')
        }
      } catch (error) {
        this.$message.error(this.$t('complaintDetail.fetchError'))
      }
    },
    getStatusText(status) {
      const key = String(status)
      const map = {
        '0': '待处理',
        '1': '处理中',
        '2': '已完成'
      }
      return map[key] || '未知'
    },
    getStatusTagType(status) {
      const s = String(status)
      const map = {
        '0': 'warning',
        '1': 'primary',
        '2': 'success'
      }
      return map[s] || 'info'
    },
    parseImages(imgStr) {
      if (!imgStr) return []
      try {
        if (typeof imgStr === 'string') {
          if (imgStr.startsWith('[')) {
            const arr = JSON.parse(imgStr)
            return Array.isArray(arr) ? arr.filter(i => i && String(i).trim()) : []
          }
          return imgStr.split(',').map(i => i && i.trim()).filter(Boolean)
        }
        if (Array.isArray(imgStr)) {
          return imgStr.filter(i => i && String(i).trim())
        }
        return []
      } catch (e) {
        console.log('解析图片失败: ', e)
        return []
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    openHandleDialog() {
      this.handleForm.rateInfo = ''
      this.handleImages = []
      this.handleDialogVisible = true
    },
    async uploadHandleImage(param) {
      try {
        const res = await uploadOwnerImage({ file: param.file })
        const url = res && (res.url || (res.data && res.data.url))
        if (!url) {
          throw new Error('上传失败，未返回图片地址')
        }
        const file = param.file
        file.url = url
        const index = this.handleImages.findIndex(item => item.uid === file.uid)
        if (index > -1) {
          this.$set(this.handleImages, index, file)
        } else {
          this.handleImages.push(file)
        }
        param.onSuccess(res)
      } catch (e) {
        console.log('上传处理图片失败:', e)
        this.$message.error(e.message || '上传处理图片失败')
        param.onError(e)
      }
    },
    handlePicturePreview(file) {
      if (file && file.url) {
        window.open(file.url, '_blank')
      }
    },
    handlePictureRemove(file) {
      if (!file || !file.url) return
      const index = this.handleImages.findIndex(img => img.url === file.url)
      if (index > -1) {
        this.handleImages.splice(index, 1)
      }
    },
    async submitHandle() {
      if (this.handleSubmitting) return
      if (!this.handleForm.rateInfo || !this.handleForm.rateInfo.trim()) {
        this.$message.warning('请输入处理内容')
        return
      }

      try {
        this.handleSubmitting = true
        const userStr = localStorage.getItem('user') || '{}'
        const user = JSON.parse(userStr)
        const staffId = user.userId || user.staffId || ''
        const staffName = user.userName || user.staffName || ''

        const now = new Date()
        const pad = n => (n < 10 ? `0${n}` : n)
        const handleTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
          now.getDate()
        )} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`

        const rateImgs =
          this.handleImages && this.handleImages.length
            ? this.handleImages.map(img => img.url || img).join(',')
            : ''

        const payload = {
          id: this.complaintDetail.id,
          complaintNo: this.complaintDetail.complaintNo,
          communityId: this.complaintDetail.communityId,
          communityName: this.complaintDetail.communityName,
          ownerId: this.complaintDetail.ownerId,
          ownerName: this.complaintDetail.ownerName,
          contactPhone: this.complaintDetail.contactPhone,
          content: this.complaintDetail.content,
          problemImgs: this.complaintDetail.problemImgs,
          rateInfo: this.handleForm.rateInfo.trim(),
          status: '2',
          handlerName: staffName,
          handleTime,
          reportType: 1,
          staffId,
          staffName
        }

        if (rateImgs) {
          payload.rateImgs = rateImgs
        }
        if (this.complaintDetail.repairId) {
          payload.repairId = this.complaintDetail.repairId
        }

        await saveOrUpdateComplaintOrder(payload)
        this.$message.success('处理成功')
        this.handleDialogVisible = false
        this.loadComplaintDetail()
      } catch (e) {
        console.log('处理投诉失败:', e)
        this.$message.error(e.message || '处理失败')
      } finally {
        this.handleSubmitting = false
      }
    },
    handleConvertToRepair() {
      if (!this.complaintDetail || !this.complaintDetail.id) {
        this.$message.warning('投诉信息不存在，无法转工单')
        return
      }

      try {
        // 将需要带到员工报修页面的投诉信息打包
        const complaintData = {
          id: this.complaintDetail.id,
          complaintNo: this.complaintDetail.complaintNo,
          ownerId: this.complaintDetail.ownerId,
          ownerName: this.complaintDetail.ownerName,
          contactPhone: this.complaintDetail.contactPhone,
          content: this.complaintDetail.content,
          problemImgs: this.problemImageList, // 瑙ｆ瀽鍚庣殑鍥剧墖 URL 鏁扮粍
          communityId: this.complaintDetail.communityId,
          communityName: this.complaintDetail.communityName
        }
        const encoded = encodeURIComponent(JSON.stringify(complaintData))
        this.$router.push({
          path: '/pages/property/staffRepair',
          query: {
            complaintData: encoded
          }
        })
      } catch (e) {
        console.log('转工单数据组装失败', e)
        this.$message.error('转工单失败，请稍后重试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.complaint-detail-container {
  .info-section {
    margin-bottom: 15px;
    color: #666;
  }

  .info-item {
    margin-bottom: 10px;

    &.vertical {
      display: flex;
      align-items: flex-start;

      label {
        margin-right: 10px;
        white-space: nowrap;
      }

      .content-text {
        flex: 1;
        line-height: 1.6;
        word-break: break-all;
      }
    }

    label {
      margin-right: 10px;
      color: #333;
      font-weight: 500;
    }
  }

  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
  }

  .detail-image {
    width: 120px;
    height: 120px;
    border-radius: 4px;
    cursor: pointer;
  }
}

.action-bar {
  margin-top: 16px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}

.handle-upload-item ::v-deep .el-form-item__content {
  text-align: left;
}
</style>
